// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmployeeMetricsResponseDto
 */
export interface IEmployeeMetricsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IEmployeeMetricsResponseDto
     */
    total_employees_count?: number;
}

/**
 * Check if a given object implements the IEmployeeMetricsResponseDto interface.
 */
export function instanceOfIEmployeeMetricsResponseDto(value: object): value is IEmployeeMetricsResponseDto {
    return true;
}

export function IEmployeeMetricsResponseDtoFromJSON(json: any): IEmployeeMetricsResponseDto {
    return IEmployeeMetricsResponseDtoFromJSONTyped(json, false);
}

export function IEmployeeMetricsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeMetricsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_employees_count': json['total_employees_count'] == null ? undefined : json['total_employees_count'],
    };
}

export function IEmployeeMetricsResponseDtoToJSON(json: any): IEmployeeMetricsResponseDto {
    return IEmployeeMetricsResponseDtoToJSONTyped(json, false);
}

export function IEmployeeMetricsResponseDtoToJSONTyped(value?: IEmployeeMetricsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total_employees_count': value['total_employees_count'],
    };
}

